module.exports = __webpack_public_path__ + "static/img/4354_phase_function_Paper_PointsHejduk_Prediction.e68d838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4354_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Wpvg
// module chunks = 0